import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';

import { useCheckoutContext } from '../../../../state/CheckoutContext';
import {
  postRemovePromoCode,
  togglePromoCodeInputVisibility
} from '../../../../state/Checkout.actions';

import styles from '../Footer.scss';

export const I18nPrefix =
  'strava.subscriptions.checkout.summary.organic.promo_code.cta';

const PromoButton = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const { packageIds, products, duration } = checkoutEntityState;
  const promotionApplied = !!products?.promotion?.code;

  const handleToggleShowPromoCodeInput = () => {
    dispatch(togglePromoCodeInputVisibility());
  };

  const handlePostRemovePromoCode = () => {
    const formData = {
      package_ids: packageIds,
      recurring: duration
    };

    postRemovePromoCode(formData, dispatch);
  };

  const handleClick = promotionApplied
    ? handlePostRemovePromoCode
    : handleToggleShowPromoCodeInput;

  const cta = promotionApplied
    ? I18n.t(`${I18nPrefix}.remove`)
    : I18n.t(`${I18nPrefix}.enter`);

  return (
    <button
      className={clsx('btn', 'btn-link', styles.actionButton)}
      onClick={handleClick}
      type="button"
    >
      {cta}
    </button>
  );
};

export default PromoButton;
